import { IEvent } from './Event.model';
import { IOrderlineSimple } from './Orderline.models';
import { ICustomerSimple } from './Customer.model';

export enum PresenceType {
  NONE = 'None',
  PRESENT = 'Present',
  ABSENT = 'Absent',
}

export enum BookingStatus {
  BOOKED = 'Booked',
  CANCELLED = 'Cancelled',
  WAITING_LIST = 'WaitingList',
  QUESTION = 'Question',
  ALL = 'All',
}

export interface IPresenceUpdate {
  bookingId?: number;
  presenceType?: PresenceType;
  reason?: string;
  origin?: string;
  force?: boolean;
}

export interface IBookingUpdate extends IPresenceUpdate {
  bookingStatus?: string;
  force?: boolean;
  sendMail?: boolean;
  refund?: boolean;
}

export interface IBookingListRequest {
  domain: string;
  customerId?: string;
  eventId?: string;
  eventGroupId?: string;
  bookingStatus?: BookingStatus;
  begin?: string;
  beginUTC?: string;
  end?: string;
  endUTC?: string;
  sortBy?: string;
  reverse?: boolean;
  page?: number;
  pageSize?: number;
}

export interface IBookingSimple {
  id: number;
  uuid: string;
  number: string;
  presenceType: PresenceType;
  origin: string;
  createdByName: string;
  status: BookingStatus;
  cancellationDate: string;
  cancellationReason: string;
  cancelledByName: string;
  createdDate: string;
  bookingSeriesId: number;
  event: IEvent;
  orderLine: IOrderlineSimple;
  bookingStatus: BookingStatus;
  customer: ICustomerSimple;
  cancelledLate?: boolean;
  cancelledWithRefund?: boolean;
  createdByUid?: string;
}

export interface IBookingCreateRequest {
  eventId: string;
  customerId: number; // Still number, should be refactored to UUID soon
  orderlineId?: number | null; // Orderline of active product from customer
  force?: boolean; // Forces a booking past set rules
  sendMail?: boolean; // If a mail should be send to the customer
  bookingOrigin?: string; // The app where the booking was made through
  presenceType: PresenceType; // The presence, 30 minutes before event every booking is present!
}

export interface IBookingSummaryEvent {
  eventId: string;
  bookingsBooked: number;
  bookingsWaiting: number;
  bookingsCancelled: number;
  publicApiClientBookings: number;
}

export interface IBookingSummaryRequest {
  eventIds: string[];
}

export interface IBooking {
  id: number;
  uuid: string;
  providerName: string;
  providerUUID: string;
  providerId: number;
  providerDomain: string;
  bookingSeriesId: number;
  eventId: number;
  eventUUID: string;
  eventSerieId: number;
  eventGroupId: number;
  eventGroupUUID: string;
  name: string;
  description: string;
  text: string;
  eventAlternateName: string;
  eventText: string;
  imageUrl: string;
  eventStart: string;
  eventStartUTC: string;
  eventEnd: string;
  eventEndUTC: string;
  customerId: number;
  customerDsplayname: string;
  customerPhoneMobile: string;
  locationName: string;
  locationStreet: string;
  locationZipCode: string;
  locationCity: string;
  locationDetailsUrl: string;
  trainerName: string;
  trainerPhone: string;
  seats: number;
  freeSeats: number;
  bookingStatus: string;
  bookingStatusText: string;
  birthday: string;
  birthdayUTC: string;
  presenceType: PresenceType;
  orderNumber: string;
  orderLineId: number;
  orderLineUUID: string;
  origin: string;
  orderLineItemId: string;
  orderLineText: string;
  orderCustomerId: number;
  orderCustomerUUID: string;
  orderCustomerDisplayName: string;
  paymentStatus: string;
  paymentStatusText: string;
  canCancel: boolean;
  canCancelWithCreditBack: boolean;
  canCancelUntil: string;
  canCancelUntilUTC: string;
  canCancelWithCreditReturnUntil: string;
  canCancelWithCreditReturnUntilUTC: string;
  creditsLeft: number;
  orderLineAmountDue: number;
  createdDate: string;
  cancellationDate: string;
  cancellationReason: string;
  orderLineCurrencySymbol: string;
  orderLineType: string;
}
